import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicReduce({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M7.461 13.747h-.56a.429.429 0 01-.428-.438l.072-2.97-3.629 3.628a.427.427 0 01-.606 0l-.404-.404a.427.427 0 010-.606l3.629-3.629-2.971.072a.426.426 0 01-.438-.428v-.56c0-.238.192-.43.428-.428l4.907-.002c.238 0 .43.192.428.428v4.91a.426.426 0 01-.428.427zm5.985-5.73H8.54a.427.427 0 01-.428-.427V2.68c0-.237.192-.429.428-.427h.56c.24 0 .433.198.428.438l-.072 2.97 3.629-3.628a.427.427 0 01.606 0l.404.404a.427.427 0 010 .606l-3.629 3.629 2.971-.072a.426.426 0 01.438.428v.56c0 .238-.192.43-.428.428z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicReduce.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicReduce.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicReduce svgRef={ref} {...props} />);
export default ForwardRef;
